/**
 * Can a failed request be sent again after a database blip?
 *
 * The backend answers a pooler drop with a 503 marked error:'ServiceUnavailable' (deliberate
 * 503s say 'Service Unavailable'). Reads always replay. Writes replay only when the server adds
 * retrySafe: its auth check failed before any of the request ran. Otherwise the drop may have
 * come after the write did, and sending it again could do it twice.
 */
export function canReplayAfterDbBlip(status: number | undefined, body: any, method: string | undefined): boolean {
  if (status !== 503 || body?.error !== 'ServiceUnavailable') return false;
  return ['get', 'head'].includes((method || 'get').toLowerCase()) || body?.retrySafe === true;
}
